import { DayOfWeek } from '@/services/api/petseo.client.wrapper';
import { DAYS_ORDER, POLISH_DAY_NAMES, POLISH_DAY_NAMES_SHORT } from '@/constants/dayOfWeek';

export { POLISH_DAY_NAMES, POLISH_DAY_NAMES_SHORT, DAYS_ORDER };

export const getDayName = (day: DayOfWeek): string => POLISH_DAY_NAMES[day];
export const getDayNameShort = (day: DayOfWeek): string => POLISH_DAY_NAMES_SHORT[day];

export const dayOfWeekOptions = DAYS_ORDER.map((day) => ({
  value: String(day),
  label: POLISH_DAY_NAMES[day],
}));

export const getDayOfWeek = (date: Date): DayOfWeek => {
  const nativeDayIndex = date.getDay();
  return nativeDayIndex === 0 ? DayOfWeek.Sunday : (nativeDayIndex as DayOfWeek);
};

export const getDayOfWeekFromDateInput = (value: string): DayOfWeek | null => {
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return null;

  return getDayOfWeek(new Date(year, month - 1, day));
};
